import { useNavigate, useSearchParams } from "react-router-dom";

import ClientBizGroupsForm from "./ClientBizGroupForm";
import ClientBizGroupsTable from "features/admin/clients/single/ClientBizGroupsTable";
import ClientCampaignForm from "./ClientCampaignForm";
import ClientCampaignTable from "features/admin/clients/single/ClientCampaignTable";
import ClientGroupsLOBForm from "./ClientGroupsLOBForm";
import ClientGroupsLOBTable from "features/admin/clients/single/ClientGroupsLOBTable";
import HStack from "shared/components/layout/stack/HStack";
import Modal from "shared/components/feedback/modals/MasterModal";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const id = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    const parsedId = Number.parseInt(id);

    switch (action) {
        case "addCampaign":
            return (
                <Modal title="Add Campaign" onRequestClose={onClose}>
                    <ClientCampaignForm key="new" onClose={onClose} />
                </Modal>
            );

        case "editCampaign":
            return Number.isNaN(parsedId) ? (
                <></>
            ) : (
                <Modal title="Edit Campaign" onRequestClose={onClose}>
                    <ClientCampaignForm
                        campaignIdToEdit={parsedId}
                        key={parsedId}
                        onClose={onClose}
                    />
                </Modal>
            );

        case "addLinkedBusinessGroup":
            return (
                <Modal title="Add Business Group Link" onRequestClose={onClose}>
                    <ClientBizGroupsForm key="new" onClose={onClose} />
                </Modal>
            );

        case "editBusinessGroupLink":
            return Number.isNaN(parsedId) ? (
                <></>
            ) : (
                <Modal
                    title="Edit Business Group Link"
                    onRequestClose={onClose}
                >
                    <ClientBizGroupsForm
                        bizGroupIdToEdit={parsedId}
                        key={parsedId}
                        onClose={onClose}
                    />
                </Modal>
            );

        case "addLineOfBusiness":
            return (
                <Modal title="Add Line of Business" onRequestClose={onClose}>
                    <ClientGroupsLOBForm key="new" onClose={onClose} />
                </Modal>
            );

        case "editLineOfBusiness":
            return Number.isNaN(parsedId) ? (
                <></>
            ) : (
                <Modal title="Edit Line of Business" onRequestClose={onClose}>
                    <ClientGroupsLOBForm
                        clientLOBIdToEdit={parsedId}
                        key={parsedId}
                        onClose={onClose}
                    />
                </Modal>
            );

        default:
            return <></>;
    }
};

const ClientGroups = () => {
    return (
        <>
            <FormPresenter />
            <HStack
                spacing="Two"
                justify="space-between"
                style={{ overflow: "auto" }}
            >
                <VStack style={{ width: "33%" }}>
                    <Text variant="Headline_2" color="Gray_1">
                        Lines of Business
                    </Text>
                    <ClientGroupsLOBTable />
                </VStack>

                <VStack style={{ width: "33%" }}>
                    <Text variant="Headline_2" color="Gray_1">
                        Campaigns
                    </Text>
                    <ClientCampaignTable />
                </VStack>

                <VStack style={{ width: "33%" }}>
                    <Text variant="Headline_2" color="Gray_1">
                        Linked Business Groups
                    </Text>
                    <ClientBizGroupsTable />
                </VStack>
            </HStack>
        </>
    );
};

export default ClientGroups;
